import request from '@/utils/request'

let QuesireApi = {
  /*获取数据*/
  getData(data, errorback) {
    return request._post('/shop/plus.quesire.quesire/index', data, errorback);
  },
  /*获取模板*/
  getTempData(data, errorback) {
    return request._post('/shop/plus.quesire.quesire/index_temp', data, errorback);
  },
  /*获取答题*/
  getAnswer(data, errorback) {
    return request._post('/shop/plus.quesire.quesire/getAnswer', data, errorback);
  },
     /*删除数据*/
     delQuesire(data, errorback) {
      return request._post('/shop/plus.quesire.quesire/delQuesire', data, errorback);
    },
         /*删除数据*/
         delQuesireAnswer(data, errorback) {
          return request._post('/shop/plus.quesire.quesire/delQuesireAnswer', data, errorback);
        },
  /*添加问卷调查*/
  add(data, errorback) {
    return request._post('/shop/plus.quesire.quesire/add', data, errorback);
  },
      /*添加抽奖白名单用户ID*/
      addUser(data, errorback) {
        return request._post('/shop/plus.quesire.quesire/addUser', data, errorback);
      },
        /*获取抽奖白名单用户列表*/
        getUser(data, errorback) {
          return request._post('/shop/plus.quesire.quesire/getUser', data, errorback);
        },
         /*删除抽奖白名单用户*/
         delUser(data, errorback) {
          return request._post('/shop/plus.quesire.quesire/delUser', data, errorback);
        },
}

export default QuesireApi;



// WEBPACK FOOTER //
// ./src/api/quesire.js